<template>
  <header class="app-header">
    <div class="container">
      <router-link to="/" class="logo-link">
        <img src="@/assets/logo.png" alt="UAMAX Logo" class="logo" />
      </router-link>
      <nav>
        <ul>
          <li v-for="item in navItems" :key="item.key">
            <a v-if="item.key === 'contact'"
               href="#"
               @click.prevent="openContactModal"
            >
              {{ item.name }}
            </a>
            <a v-else-if="item.isExternal || item.link.startsWith('#')"
               :href="item.link"
               @click="item.link.startsWith('#') && item.link.length > 1 ? navigateToSection($event, item.link) : null"
               :target="item.isExternal ? '_blank' : null">
              {{ item.name }}
            </a>
            <router-link v-else :to="item.link">{{ item.name }}</router-link>
          </li>
        </ul>
      </nav>
      <div class="header-actions">
        <button @click="switchLanguage" class="lang-switcher">
          <!-- 假设你使用根据当前语言显示不同提示图标的方案 -->
          <!-- <img v-if="$i18n.locale === 'zh'" src="@/assets/icons/earth-icon-en.svg" alt="Switch to English" class="lang-icon" />
          <img v-else src="@/assets/icons/earth-icon-zh.svg" alt="切换到中文" class="lang-icon" /> -->
          <!-- 如果只有一个通用图标，使用下面这行并注释掉上面两行 -->
          <!-- <img src="@/assets/icons/global-language-icon.svg" alt="Language" class="lang-icon" /> -->
          <span class="lang-text">{{ $t('header.langSwitchTo') }}</span>
        </button>
      </div>
    </div>
    <ContactFormModal :show="isContactModalVisible" @close="closeContactModal" />
  </header>
</template>

<script>
import ContactFormModal from '@/components/ContactFormModal.vue';

export default {
  name: 'AppHeader',
  components: {
    ContactFormModal,
  },
  data() {
    return {
      isContactModalVisible: false,
    };
  },
  computed: {
    navItems() {
      return [
        { key: 'home', name: this.$t('header.nav.home'), link: '/' },
        { key: 'about', name: this.$t('header.nav.about'), link: '/about' },
        { key: 'solutions', name: this.$t('header.nav.solutions'), link: '/major-media' },
        { key: 'account', name: this.$t('header.nav.account'), link: '/account-service' },
        { key: 'products', name: this.$t('header.nav.products'), link: '/major-media-services' },
        { key: 'contact', name: this.$t('header.nav.contact'), link: '#' },
      ];
    },
  },
  methods: {
    switchLanguage() {
      const newLocale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLocale;
      localStorage.setItem('userLanguage', newLocale);
    },
    openContactModal() {
      this.isContactModalVisible = true;
    },
    closeContactModal() {
      this.isContactModalVisible = false;
    },
    navigateToSection(event, sectionIdWithPossiblePath) {
      event.preventDefault();
      const parts = sectionIdWithPossiblePath.split('#');
      const path = parts[0];
      const sectionId = parts[1] ? `#${parts[1]}` : null;

      const navigateAndScroll = () => {
        if (sectionId) {
          this.$nextTick(() => {
            const element = document.querySelector(sectionId);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              console.warn(`未找到元素: ${sectionId}`);
            }
          });
        } else if (path === '/') {
             window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      };

      if (path && this.$route.path !== path) {
        this.$router.push(path).then(navigateAndScroll).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          } else {
            navigateAndScroll();
          }
        });
      } else {
        navigateAndScroll();
      }
    }
  }
};
</script>

<style scoped>
.logo-link {
  display: inline-block;
  line-height: 0;
}
.app-header {
  background-color: #ffffff;
  padding: 15px 0;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 40px;
}

nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}

nav li {
  margin-left: 25px;
}

nav a, nav .router-link-active, nav .router-link-exact-active {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  padding: 5px 0;
  transition: color 0.3s ease;
  cursor: pointer;
}

nav a:hover, nav .router-link-active:hover, nav .router-link-exact-active:hover {
  color: #007bff;
}

nav .router-link-exact-active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

.header-actions {
  display: flex;
  align-items: center;
}

.lang-switcher {
  display: inline-flex;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 8px 15px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  white-space: nowrap;
}

.lang-switcher:hover {
  background-color: #e9ecef;
  border-color: #ced4da;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.lang-switcher:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.lang-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

@media (max-width: 768px) {
  nav {
    display: none;
  }
  .lang-switcher {
    /* padding: 6px 12px; */
    /* font-size: 0.85rem; */
  }
  .lang-icon {
    /* height: 14px; */
    /* width: 14px; */
    /* margin-right: 6px; */
  }
}
</style>